import { Component } from "../../../components/base/Component";
import { ComponentFactory } from "../../../services/ComponentFactory";
import { ICfa } from "../../../models/ICfa";

declare global {
	interface Window {
		dataLayer: any[];
	}
}

export class StillHaveQuestion extends Component {
	constructor(_element: HTMLElement, _app: ICfa) {
		super(_element, _app);

		this.applyDatalayerEvent();
	}

	private applyDatalayerEvent(): void {
		const datalayerButtons = this._element.querySelectorAll<HTMLElement>("[data-datalayer]");

		if (datalayerButtons.length > 0) {
			datalayerButtons.forEach((button: HTMLElement) => {
				if (button.tagName.toLowerCase() === "a") {
					button.addEventListener("click", (e) => {
						const href = (button as HTMLAnchorElement).href;
						if (!href) return;

						e.preventDefault();

						const event = {
							event: "content_click", // This is the required key
							module_name: "cares_form",
							page_url: window.location.href,
							link_category: "click_to_call",
							link_text: button.innerText,
							link_url: href,
							method: "text_link"
						};

						console.info(`Pushing to dataLayer: ${JSON.stringify(event)}`);

						window.dataLayer = window.dataLayer || [];
						window.dataLayer.push(event);

						// Delay to let GTM tags fire
						setTimeout(() => {
							window.location.href = href;
						}, 200);
					});
				}
			});
		}
	}
}

ComponentFactory.registerComponent("StillHaveQuestion", StillHaveQuestion);
